import { motion } from "framer-motion";
import React from "react";

const easeLux = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "", as = "div" }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: easeLux }}
    >
      {children}
    </MotionTag>
  );
};

// Word/line masked reveal for headlines
export const MaskedLines = ({ lines, className = "", lineClass = "", startDelay = 0.2 }) => {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            className={`block ${lineClass}`}
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1.1, delay: startDelay + i * 0.14, ease: easeLux }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

export const overlineVariants = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 1, delay: 0.1 } },
};
